import { chat } from './chat';

export const ai = ($http: HttpApi) => ({
  chat: chat($http),
});
